import { ChangeDetectorRef, Directive, Input, OnDestroy, TemplateRef, ViewContainerRef } from '@angular/core';
import { BehaviorSubject, combineLatestWith, Observable, Subject, takeUntil } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { map } from 'rxjs/operators';

@Directive({
  selector: '[tdUserIdMatch]',
  standalone: false,
})
export class UserIdMatchDirective implements OnDestroy {
  private hasView = false;
  private destroy$$ = new Subject<void>();
  private id$$ = new BehaviorSubject<string>(null);
  private isMatch$: Observable<boolean>;

  private elseTemplateRef$$ = new BehaviorSubject<TemplateRef<any>>(null);

  @Input()
  public set tdUserIdMatch(id: string) {
    this.id$$.next(id);
  }

  @Input()
  public set tdUserIdMatchElse(templateRef: TemplateRef<any>) {
    this.elseTemplateRef$$.next(templateRef);
  }

  constructor(
    private authService: AuthService,
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private cd: ChangeDetectorRef,
  ) {
    this.isMatch$ = this.authService.userInfo$.pipe(
      combineLatestWith(this.id$$),
      map(([userInfo, id]) => !!id && userInfo?.id === id),
    );
    this.listenForViewUpdates();
  }

  public ngOnDestroy(): void {
    this.destroy$$.next();
    this.destroy$$.unsubscribe();
  }

  private listenForViewUpdates() {
    this.isMatch$
      .pipe(takeUntil(this.destroy$$), combineLatestWith(this.elseTemplateRef$$))
      .subscribe(([isMatch, elseRef]) => {
        if (!isMatch) {
          this.clearView();
          if (elseRef) {
            this.viewContainer.createEmbeddedView(elseRef);
            this.hasView = true;
          }
          this.cd.markForCheck();
        } else {
          this.clearView();
          this.viewContainer.createEmbeddedView(this.templateRef);
          this.hasView = true;
          this.cd.markForCheck();
        }
      });
  }

  private clearView() {
    if (this.hasView) {
      this.viewContainer.clear();
      this.hasView = false;
      this.cd.markForCheck();
    }
  }
}
